"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapabilityBadge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_ui_1 = require("@yanzi/react-ui");
const react_1 = require("react");
const useCapabilities_1 = require("../../hooks/useCapabilities");
const Capability_1 = require("../Capability");
function CapabilityBadge(_a) {
    var { small, text } = _a, props = __rest(_a, ["small", "text"]);
    const title = react_1.useContext(Capability_1.Context);
    const isDeveloper = useCapabilities_1.useCapabilities().has('developer');
    if (!isDeveloper) {
        return null;
    }
    if (title === null) {
        return null;
    }
    if (text) {
        return (jsx_runtime_1.jsx(react_ui_1.Circle, Object.assign({ diameter: "0.8rem", title: title, backgroundColor: "info", display: "inline-block", mb: "-0.1rem", ml: 1 }, props), void 0));
    }
    if (small) {
        return (jsx_runtime_1.jsx(react_ui_1.Badge, Object.assign({ title: title, backgroundColor: "info", width: "0.8rem", height: "0.8rem", borderRadius: "0.4rem", m: 1, p: 0, position: "absolute", display: "block !important" }, props), void 0));
    }
    return (jsx_runtime_1.jsx(react_ui_1.Badge, Object.assign({ backgroundColor: "info", color: "#fff", position: "absolute", shouldTruncate: true, m: 1, title: title }, props, { children: title }), void 0));
}
exports.CapabilityBadge = CapabilityBadge;
//# sourceMappingURL=index.js.map